export default [
  {
    zh: '整机编号',
    en: 'Device Code',
    dataIndex: 'devicCode',
    key: 'deviceCode',
    width: 200
  },
  {
    zh: '公司名称',
    en: 'Company',
    dataIndex: 'company',
    key: 'company',
    width: 460
  },
  {
    zh: '机型',
    en: 'Model',
    dataIndex: 'model',
    key: 'model',
    width: 230
  },
  {
    zh: '进气温度(℃)',
    en: 'Inlet Temperature',
    dataIndex: 'inletTemperature',
    key: 'inletTemperature'
  },
  {
    zh: '排气温度(℃)',
    en: 'Exhaust Temperature(℃)',
    dataIndex: 'exhaustTemperature',
    key: 'exhaustTemperature'
  },
  {
    zh: '主风机变频温度(℃)',
    en: 'Main Fan Inverter Temperature(℃)',
    dataIndex: 'mainFanInverterTemperature',
    key: 'mainFanInverterTemperature'
  },
  {
    zh: '主风机输出频率(Hz)',
    en: 'Main Fan Out Rate(Hz)',
    dataIndex: 'mainFanOutRate',
    key: 'mainFanOutRate'
  },
  {
    zh: '占比',
    en: 'Percentage',
    dataIndex: 'percentage',
    key: 'percentage'
  }
]